import { gql } from '@apollo/client';

export const EXPORT_INSTITUTIONS_IN_INSTITUTION_PORTAL = gql`
  query ExportInstitutionsInInstitutionPortal($input: InstitutionPortalInstitutionsInput) {
    institutions: exportInstitutionsInInstitutionPortal(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          name
          ecdServiceType
          classification
          registrationStatus {
            name
          }
          progStatus {
            name
          }
          pcrLevel
          progLevel
          progCertificateIssueDate
          progCertificateExpiryDate
          progCertificateNumber
          certificateNumber
          issueDate
          expiryDate
          registrationType {
            name
          }
          newOrRenewal
          organisationName
          networkName
          privateOrNpo
          registrationNumber
          npoNumber
          yearOfReceipt
          receivedEcdEsrf
          dateEcdEsrfReceived
          emisNumber
          country {
            name
          }
          province {
            name
          }
          districtMunicipality {
            name
          }
          localMunicipality {
            localMunicipality
          }
          district {
            name
          }
          wardID
          wardLabel
          streetAddress
          suburb
          feeLevel
          townshipVillage
          townCity
          locality
          postalAddress
          postalCode
          gisAltitude
          gisLatitude
          gisLongitude
          gisSource
          nearestPointOfInterest
          pointOfInterest
          officeEmailAddress
          officeContactNumber
          registrationOffice {
            institution {
              name
            }
          }
          sspSupervisor {
            firstName
            lastName
          }
          socialServicesProfessional {
            firstName
            lastName
          }
          duplicateReference
          duplicateAction
          reasonForDuplicateAction
          trackingCode
          verified
          validated
          dataSource
          isArchived
          updatedAt
          numberOfChildrenFunded
          ecdRegistrationLatest {
            registrationType {
              name
            }
            newOrRenewal
            certificateNumber
            issueDate
            expiryDate
            identifiedBy
            dateIdentified
          }
          ecdFacilityDetail {
            building
            sharedBuilding
            numberOfClassrooms
            buildingOwner
            landowner
            kitchen
            outdoorPlayArea
            typesOfToilets
            separateToilets
            numToilets
            childrenToilets
            adultToilets
            mainSourceOfPowerHeating
            mainSourceOfPowerLighting
            mainSourceOfPowerCooking
            mainSourceOfWater
            mainSourceOfWaterOther
            whatHandwashingFacility
          }
          nutrition {
            mealsProvided
            foodProvider
            foodProviderOther
            year
          }
          ecdFinanceDetails {
            monthlyFeeRangeLowest
            monthlyFeeRangeHighest
            mainFundingSource
            receivesDBESubsidy
            fundedThroughEquitableShare
            fundedThroughConditionalGrant
            fundedThroughTopUpSubsidy
            assessedForMaintenanceGrant
            receivedMaintenanceGrant
            numChildrenSubsidisedCG
            numChildrenSubsidisedES
            numChildrenSubsidisedTU
            monthlyCGBudgetTotal
            monthlyESBudgetTotal
            feeLevel
            year
            monthlyTopUpSubsidyTotal
            infrastructureGrantBudget
          }
          ecdEnrolmentData {
            numberOfChildrenEnrolled
            ageRange0To18Months
            ageRange18MonthsTo3Years
            ageRange0To12Months
            ageRange1To2Years
            ageRange2To3Years
            ageRange3To4Years
            ageRange4To5Years
            ageRange5To6Years
            gradeROffered
            registeredCapacity
            year
          }
          ecdStaffData {
            numberOfStaff
            male
            female
            paid
            unpad
            fullTime
            partTime
            gradeREducators
            ecdPractitioners
            managerialStaff
            supportStuff
            accreditedECDSkillsProgram
            nqfLevel4to5ECD
            nqfLevel6to9ECD
            fullTimeMales
            fullTimeFemales
            fullTimeGenderOther
            partTimeMales
            partTimeFemales
            partTimeGenderOther
            year
          }
          organisation {
            contactList {
              primaryContact
              designation
              firstName
              lastName
              emailAddress
              contactNumber
            }
          }
          censusDataLatest {
            space
            toilets_gender
            potable
            count_staff_gender_other
            count_staff_contract_permanent
            count_staff_contract_temporary
            count_staff_contract_substitute
            professionals_practitioners
            fundingother
            year
          }
        }
      }
    }
  }
`;
